export default __webpack_public_path__ + "static/media/rutasprivadas.65a5d4e3.png";